<template>
  <div class="wrapper">
    <!-- 日期选择 -->
    <div class="date-select">
      <!-- 切换日期 -->
      <div class="dateBox">
        <div class="box_left" :style="{'marginLeft':'-'+scrollLeft}">
          <div
            class="scroll_data_item"
            v-for="(item,index) in selectDataArr"
            :key="index"
            @click="selectDate(item.date)"
          >
            <span v-if="index==0" class="item_t">今天</span>
            <span v-else-if="index==1" class="item_t">明天</span>
            <span v-else class="item_t">{{item.week}}</span>
            <span class="item_b">{{item.day}}</span>
            <span class="item_l" v-if="item.date == activeDate"></span>
          </div>
        </div>
        <div class="select_data border-left" @click.stop="changeDate">
          <img class="dateIcon" src="../../assets/images/icon_arrows_unfold.png" />
        </div>
      </div>
      <!-- 选择时间 -->
      <div class="date-select-form border-top" v-if="timeList.length">
        <div
          v-for="(item,index) in timeList"
          :key="index"
          :class="['date-select-form-row',(selectStart < index&&selectEnd > index)?'between':'']"
        >
          <div class="betweenBg">
            <div class="startBg" v-if="selectStart == index"></div>
            <div class="endBg" v-if="selectEnd == index"></div>
            <div
              :class="['date-select-form-item',selectStart==index?'start':'',selectEnd==index?'end':'']"
              @click="selectBetween(index,item.status)"
            >
              <span
                :class="['time',item.status=='1'||(index>0&&timeList[index-1].status == '1')?'keyi':'']"
                v-if="selectStart!=index&&selectEnd!=index"
              >{{item.time}}</span>
              <span class="timeText" v-if="selectStart==index&&selectStart!=selectEnd">{{item.time}}</span>
              <span class="timeText" v-if="selectEnd==index&&selectStart!=selectEnd">{{item.time}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box" v-if="selectEnd !== 9999">
      <div class="msgBox">
        <div class="msgLeft">
          <span class="label">总计时段</span>
          <span
            class="timeInterval"
          >{{activeDate}} {{activeWeekDay}} {{timeList[selectStart].time}}-{{timeList[selectEnd].time}}</span>
        </div>
        <span class="chinese">{{hourCount}}小时</span>
      </div>
      <div class="freeBox" v-if="meetingExemptCompany.length !== 0">
        <div class="msgLeft">
          <span class="label">免费额度</span>
          <span
            class="exempt"
            v-if="activeCompany"
          >已抵用{{freeTime}}小时 剩余{{hourCount > activeCompanyObj.exemptTime ? 0 : activeCompanyObj.exemptTime - hourCount}}小时</span>
        </div>
        <yd-switch
          class="switch"
          :color="common.theme == 1 ? '#f6c400':'#1740da' "
          v-model="pretermission"
          :callback="switchChange"
        ></yd-switch>
      </div>
      <div class="msgBox" v-if="pretermission" @click="selectCompany">
        <span class="label">企业</span>
        <div class="valueBox">
          <!-- <picker value="{{index}}" bindchange="changeCompany" range="{{companyList}}"> -->
          <!-- <div class="tui-picker-detail">{{companyList[index]}}</div>
          </picker>-->
          <p class="tui-picker-detail">{{companyList[index]}}</p>
          <img src="../../assets/images/icon_indicator_next.png" />
        </div>
      </div>
    </div>
    <!-- 提交 -->
    <div class="submit_bottom">
      <div class="submitCompanyLeft">
        <div class="submitCompanyLeftTop" v-if="selectEnd !== 9999">
          <span class="submitSumText">合计:</span>
          <span class="submitNum">¥{{(totalPrice-freePrice).toFixed(2)}}</span>
          <!-- <span class="submitNum">¥{{activeCompany.length ? accSubtr(totalPrice,freePrice) : totalPrice}}</span> -->
        </div>
        <span class="FreeLine" v-if="activeCompany.length">免费额度-¥{{freePrice.toFixed(2)}}</span>
      </div>
      <span :class="['submit_btn',selectEnd !== 9999?'':'unClick']" @click="submitOrder">去结算</span>
    </div>
    <!-- 日期控件 -->
    <yd-datetime
      style="display:none;"
      ref="datetime"
      @input="bindDateChange"
      type="date"
      v-model="date"
      :start-date="toView"
    ></yd-datetime>
    <!-- 下拉框选择 -->
    <mt-popup v-model="popupVisible" position="bottom" class="mint-popup">
      <mt-picker
        class="picker"
        :slots="dataList"
        :visible-item-count="5"
        :show-toolbar="true"
        ref="picker"
      >
        <div class="picker_wrap">
          <div class="picker_btn" @click="popupVisible=false">取消</div>
          <div class="picker_btn2" @click="handleConfirm">确认</div>
        </div>
      </mt-picker>
    </mt-popup>
  </div>
</template>
<script>
import util from "../../utils/util";
import { mapState } from "vuex";
import { getMeetingPriceList, checkMeetingTime } from "../../utils/api";
import Scroll from "../../components/scroll";
export default {
  name: "roomDate",
  components: {
    Scroll
  },
  data() {
    return {
      value: "请选择日期",
      timeList: [], //时间列表
      betweenArray: [],
      selectStart: 9999,
      selectEnd: 9999,
      day_week: [],
      currentDate: "",
      index: 0, //选中企业的index
      hourCount: 0,
      totalPrice: 0,
      bondItemId: "",
      scrollLeft: 0,
      dataList: [],
      popupVisible: false,
      minPrice: 0,
      dayTime: 100, //一天超过多少小时算一天的价格
      activeWeekDay: "",
      meetingExemptCompany: [],
      pretermission: false, //是否选中免额时长
      companyList: [], //可享受免费时长的公司列表
      activeCompany: "", //选中的公司名字
      activeCompanyObj: {},
      freeTime: 0, //面额时长
      freePrice: 0,
      priceArray: [],
      saleTime: 0,
      maxSaleTime: "", //最大可订时常
      selectDataArr: [], //可选日期数组
      reserveTime: "", //可以预订几天，如果没有，默认可预订未来一个月
      activeDate: util.formatTime(new Date(), 4),
      toView: util.formatTime(new Date(), 4),
      endDate: util.formatTime(new Date(), 5),
      date: util.formatTime(new Date(), 4)
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    this.id = this.$route.params.id;
    this.activeWeekDay = "周" + this.getWeek(this.activeDate);
    this.getMeetingPriceList();
  },
  activated() { },
  methods: {
    handleConfirm() {
      this.popupVisible = false
      var valve = this.$refs.picker.getValues()[0];
      this.companyList.forEach((item, index) => {
        if (item == valve) {
          this.index = index
        }
      })
      let that = this;
      that.meetingExemptCompany.forEach((item, index) => {
        if (item.companyName == valve) {
          that.activeCompanyObj = item
        }
      })
      this.jisuanPrice();
    },
    selectCompany() {
      this.popupVisible = true;
      this.dataList = [{
        flex: 1,
        values: this.companyList,
        className: 'slot1',
        textAlign: 'center'
      }]
    },
    changeDate() {
      this.$refs.datetime.open();
    },
    // 日期切换
    bindDateChange(val) {
      this.selectDataArr.forEach((item, index) => {
        if (val == item.date) {
          this.scrollLeft = 100 * index / 100 + "rem";
        }
      });
      this.activeDate = val;
      this.pretermission = false; //是否选中免额时长
      this.companyList = []; //可享受免费时长的公司列表
      this.activeCompany = ""; //选中的公司名字
      this.activeCompanyObj = {};
      this.freeTime = 0; //面额时长
      this.betweenArray = [];
      this.selectStart = 9999;
      this.selectEnd = 9999;
      this.totalPrice = "";
      this.minPrice = 0;
      this.timeList = "";
      this.activeWeekDay = "周" + this.getWeek(val);
      console.log(val)
      this.getMeetingPriceList();
    },
    // 切换是否使用免费时常
    switchChange() {
      if (!this.pretermission) {
        this.pretermission = false;
        this.activeCompany = "";
        this.activeCompanyObj = {};
      } else {
        this.pretermission = true;
        this.activeCompany = this.meetingExemptCompany[0].companyName;
        this.activeCompanyObj = this.meetingExemptCompany[0];
      }
      this.jisuanPrice();
    },
    // 日期获取周几
    getWeek(value) {
      let end = ''
      switch (
      new Date(value.replace(new RegExp(/-/gm), "/") + " 00:00:00").getDay()
      ) {
        case 1:
          end = "一";
          break;
        case 2:
          end = "二";
          break;
        case 3:
          end = "三";
          break;
        case 4:
          end = "四";
          break;
        case 5:
          end = "五";
          break;
        case 6:
          end = "六";
          break;
        case 0:
          end = "日";
          break;
        default:
      }
      return end
    },
    selectBetween(index, status) {
      let statusPre = "";
      if (index > 0) {
        statusPre = this.timeList[index - 1].status;
      }
      let that = this;
      let len = that.betweenArray.length;
      console.log(len)
      // length小于2   push
      // length大于等于2  取最大和最小
      if (status == "1" || index > 0 && statusPre == "1") {
        if (len == 0) {
          let betweenArray = that.betweenArray;
          betweenArray.push(index);
          that.betweenArray = betweenArray;
          that.selectStart = index;
        } else if (len == 1 && index != that.betweenArray[0]) {
          this.checkMeetingTime(index);
        } else if (len == 2) {
          this.pretermission = false;
          this.switchChange()
          let betweenArray = [];
          betweenArray.push(index);
          that.selectEnd = 9999;
          that.betweenArray = betweenArray;
          that.selectStart = index;
        }
      } else {
        util.showToast("当前时间不可预订");
      }
    },
    selectDate(data) {
      this.activeDate = data;
      this.pretermission = false; //是否选中免额时长
      this.companyList = []; //可享受免费时长的公司列表
      this.activeCompany = ""; //选中的公司名字
      this.activeCompanyObj = {};
      this.freeTime = 0; //面额时长
      this.betweenArray = [];
      this.selectStart = 9999;
      this.selectEnd = 9999;
      this.totalPrice = "";
      this.minPrice = 0;
      this.timeList = "";
      this.activeWeekDay = "周" + this.getWeek(data);
      this.getMeetingPriceList();
    },
    checkMeetingTime(index) {
      let that = this;
      let selectHours = Math.abs(that.betweenArray[0] - index) / 2; //选择的时长
      console.log(this.reserveTime);

      if (this.maxSaleTime || this.reserveTime !== '') {
        let params = {
          userId: this.common.userId,
          meetingRoomId: this.id,
          payDate: this.activeDate,
          payTime: selectHours
        };
        checkMeetingTime(params).then(res => {
          if (res.res.code == 10000) {
            let betweenArray = that.betweenArray;
            betweenArray.push(index);
            that.betweenArray = betweenArray;
            that.selectStart = Math.min(that.betweenArray[0], index);
            that.selectEnd = Math.max(that.betweenArray[0], index);
            that.jisuanPrice();
          } else {
            util.showModal("", res.res.msg, false, "我知道了", "", "");
          }
        });
      } else {
        let betweenArray = that.betweenArray;
        betweenArray.push(index);
        that.betweenArray = betweenArray;
        that.selectStart = Math.min(that.betweenArray[0], index);
        that.selectEnd = Math.max(that.betweenArray[0], index);
        that.jisuanPrice();
      }
    },
    // 遍历设置可预订时间
    jisuanPrice() {
      let that = this;
      // 计算价格
      let selectHours = (that.selectEnd - that.selectStart) / 2; //选择的时长
      if (this.activeCompany) {
        if (selectHours > this.activeCompanyObj.exemptTime) {
          this.freeTime = this.activeCompanyObj.exemptTime;
        } else {
          this.freeTime = selectHours;
        }
      } else {
        this.freeTime = 0;
      }
      let totalPrice = 0;
      let timeList = that.timeList;
      let priceArray = [];
      //选择的时间减去免额时间 小于 一天的时间 或者 不存在一天的时间价格
      if (
        util.accSubtr(selectHours, this.freeTime) - 0 < that.dayTime ||
        !timeList[that.selectStart].dayPrice
      ) {
        for (let i = 0; i < timeList.length; i++) {
          if (i > that.selectStart - 1 && i < that.selectEnd) {
            totalPrice = util.add(
              totalPrice,
              timeList[i].unitPrice ? timeList[i].unitPrice : 0
            );
            priceArray.push(timeList[i].unitPrice ? timeList[i].unitPrice : 0);
          }
        }
      } else {
        for (let i = 0; i < timeList.length; i++) {
          if (i > that.selectStart - 1 && i < that.selectEnd) {
            priceArray.push(timeList[i].unitPrice ? timeList[i].unitPrice : 0);
          }
        }
        totalPrice = timeList[that.selectStart].dayPrice;
      }
      that.priceArray = priceArray; //选中的每一天的价格集合
      that.totalPrice = totalPrice;
      that.freePrice = 0;
      that.hourCount = selectHours; //总计选中的时长
      that.minPrice = Math.min.apply(null, priceArray) * 2; //价格中最小的值
      this.freeLine();
    },
    freeLine() {
      var that = this;
      if (this.activeCompany) {
        let priceArray = this.priceArray;
        priceArray.sort((a, b) => {
          return a - b;
        });
        if (
          util.accSubtr(that.hourCount, this.freeTime) - 0 < that.dayTime ||
          !that.timeList[that.selectStart].dayPrice
        ) {
          for (var i = 0; i < this.freeTime * 2; i++) {
            that.freePrice = util.add(that.freePrice, Number(priceArray[i]));
          }
        } else if (this.freeTime > this.dayTime) {
          that.freePrice = this.totalPrice;
        }
      }
    },
    getMeetingPriceList() {
      let that = this,
        company = [];
      util.showLoading();
      getMeetingPriceList({
        userId: this.common.userId,
        meetingRoomId: this.id,
        date: this.activeDate
      }).then(res => {
        util.hideLoading();
        console.log(res);
        if (res.res.code === 10000 && res.body) {
          this.saleTime = res.body.saleTime; //最少时长
          this.maxSaleTime = res.body.maxSaleTime;
          this.reserveTime = res.body.reserveTime;
          this.getSelectDataArr(res.body.reserveTime);
          // 有免额时长公司数据
          if (res.body.meetingExemptCompanyOutputs.length !== 0) {
            for (var key in res.body.meetingExemptCompanyOutputs) {
              company.push(
                res.body.meetingExemptCompanyOutputs[key].companyName
              );
            }
            that.meetingExemptCompany = res.body.meetingExemptCompanyOutputs;
            that.companyList = company;
          } else {
            that.meetingExemptCompany = [];
            that.companyList = [];
          }
          if (res.body.respOutputs) {
            that.timeList = res.body.respOutputs;
            that.dayTime = res.body.dayTime || 100;
          } else {
            util.showToast("当前没有可预订时段");
          }
        } else {
          util.showToast(res.res.msg);
        }
      });
    },
    // 得到可选时间日期
    getSelectDataArr(val) {
      let arr = [];
      if (val == 0 || val) {
        for (var i = 0; i < val + 1; i++) {
          arr.push({
            date: util.targetDay(i, "date"),
            week: this.getWeek(util.targetDay(i, "date")),
            day: util.targetDay(i, "day")
          });
        }
      } else {
        for (var i = 0; i < 30; i++) {
          arr.push({
            date: util.targetDay(i, "date"),
            week: this.getWeek(util.targetDay(i, "date")),
            day: util.targetDay(i, "day")
          });
        }
      }
      this.selectDataArr = arr;
    },
    // 去结算
    submitOrder() {
      let that = this;
      if (this.selectEnd == "9999") {
        return;
      }
      if (this.saleTime > this.hourCount) {
        util.showToast("会议室" + this.saleTime + "小时起订");
        return;
      }
      let timeList = that.timeList;
      for (let i = 0; i < timeList.length; i++) {
        if (i > that.selectStart - 1 && i < that.selectEnd) {
          if (timeList[i].status != "1") {
            util.showToast("当前选择包含不可预订时段");
            return;
          }
        }
      }
      if (this.activeCompany) {
        this.$router.push({
          path: `/yudingName/?id=${this.id}&totalPrice=${this.totalPrice * 1000}&timeList=${JSON.stringify(this.timeList)}&activeWeekDay=${this.activeWeekDay}&selectStart=${this.selectStart}&selectEnd=${this.selectEnd}&selectDay=${this.activeDate}&hour=${this.hourCount}&activeCompanyObj=${JSON.stringify(this.activeCompanyObj)}&freePrice=${this.freePrice}`
        })
        // this.$router.push({
        //   path:`/roomPay/?id=${this.id}&totalPrice=${this.totalPrice * 1000}&timeList=${JSON.stringify(this.timeList)}&activeWeekDay=${this.activeWeekDay}&selectStart=${this.selectStart}&selectEnd=${this.selectEnd}&selectDay=${this.activeDate}&hour=${this.hourCount}&activeCompanyObj=${JSON.stringify(this.activeCompanyObj)}&freePrice=${this.freePrice}`
        // })
      } else {
        this.$router.push({
          path: `/yudingName/?id=${this.id}&totalPrice=${this.totalPrice * 1000}&timeList=${JSON.stringify(this.timeList)}&activeWeekDay=${this.activeWeekDay}&selectStart=${this.selectStart}&selectEnd=${this.selectEnd}&selectDay=${this.activeDate}&hour=${this.hourCount}`
        })
        // this.$router.push({
        //   path:`/roomPay/?id=${this.id}&totalPrice=${this.totalPrice * 1000}&timeList=${JSON.stringify(this.timeList)}&activeWeekDay=${this.activeWeekDay}&selectStart=${this.selectStart}&selectEnd=${this.selectEnd}&selectDay=${this.activeDate}&hour=${this.hourCount}`
        // })
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.wrapper {
  background: @colore;
}
/*切换选择*/
.date-select {
  background: #fff;
}
.dateBox {
  height: 88px;
  .flex();
  width: 100%;
  align-items: center;
  overflow: hidden;
}
.box_left {
  height: 88px;
  .flex();
  flex: 1;
  flex-wrap: nowrap;
  align-items: center;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
.scroll_data_item {
  width: 100px;
  height: 88px;
  display: block;
  position: relative;
  text-align: center;
  overflow: hidden;
  flex-shrink: 0;
}
.scroll_data_item span {
  display: block;
}
.item_t {
  font-size: 22px;
  color: rgba(102, 102, 102, 1);
  line-height: 32px;
  margin-top: 12px;
}
.item_b {
  height: 34px;
  font-size: 24px;
  color: rgba(102, 102, 102, 1);
  line-height: 34prx;
}
.item_l {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
  width: 32px;
  height: 6px;
  background: @color17;
}
.select_data {
  position: relative;
  height: 88px;
  width: 88px;
  .flex();
  justify-content: center;
  align-items: center;
}
.picker span {
  height: 60px;
  font-size: 44px;
  color: rgba(51, 51, 51, 1);
  line-height: 60px;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  bottom: 0;
  opacity: 0;
}
.dateIcon {
  width: 32px;
  height: 32px;
  display: block;
}
/*时段选择*/

.date-select-form {
  justify-content: flex-start;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  padding-top: 12px;
}

.date-select-form-row {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 107px;
  margin-bottom: 12px;
}

.betweenBg {
  width: 107px;
  height: 76px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
}

.startBg {
  width: 60px;
  height: 76px;
  position: absolute;
  left: 53px;
  background-color: #f1f4fd;
}

.endBg {
  width: 60px;
  height: 76px;
  position: absolute;
  right: 53px;
  background-color: #f1f4fd;
}

.date-select-form-item {
  width: 76px;
  height: 76px;
  border-radius: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.start {
  background-color: @color17;
  position: relative;
  z-index: 2;
}

.end {
  background-color: @color17;
  position: relative;
  z-index: 2;
}

.time {
  font-size: 22px;
  color: rgba(51, 51, 51, 0.3);
}

.timeText {
  font-size: 22px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
}

.timeTextS,
.timeTextE {
  font-size: 20px;

  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
}
.switch {
  // background:@color17 !important;
  // border-color:@color17 !important;
}
.between {
  background-color: #f1f4fd;
}

.keyi {
  color: #333;
}

.submit_bottom {
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 108px;
  padding-left: 40px;
  padding-right: 20px;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(234, 234, 234, 1);
}
.bottom_isIpx {
  padding-bottom: 68px;
}

.submitCompanyLeft {
  justify-content: center;
}

.submitCompanyLeftTop {
  flex-direction: row;
  display: flex;
  align-items: flex-end;
  height: 44px;
}

.submitLeft {
  flex-direction: row;
  display: flex;
  align-items: flex-end;
  height: 56px;
}

.submitSumText {
  font-size: 28px;

  color: rgba(51, 51, 51, 1);
  line-height: 40px;
}

.submit_btn {
  width: 192px;
  height: 68px;
  background-color: @color17;
  border-radius: 4px;
  font-size: 28px;
  color: rgba(255, 255, 255, 1);
  line-height: 68px;
  text-align: center;
}
.unClick {
  background-color: #eaeaea;
  color: #999;
  // margin-left: 498px;
}
/*日期选择控件*/

.box {
  position: fixed;
  bottom: 108px;
  left: 0;
  right: 0;
  margin: 20px;
  background: #fff;
  z-index: 2;
  padding: 32px 28px 14px 28px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #eaeaea;
}
.box_isIpx {
  bottom: 176px;
}
.msgBox {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px;
  width: 100%;
  margin-bottom: 18px;
}

.freeBox {
  flex-direction: row;
  display: flex;
  margin-bottom: 18px;
  justify-content: space-between;
  align-items: center;
}

.msgLeft,
.msgRight {
  flex-direction: row;
  display: flex;
  align-items: center;
  height: 36px;
}

.label {
  font-size: 26px;
  color: rgba(51, 51, 51, 1);
  line-height: 36px;
  margin-right: 20px;
}

.timeInterval {
  font-size: 24px;

  color: rgba(153, 153, 153, 1);
  line-height: 36px;
}

.chinese {
  font-size: 26px;

  color: rgba(51, 51, 51, 1);
  line-height: 36px;
}

.yjt {
  width: 15px;
  height: 26px;
  margin-left: 19px;
}

.submitNum {
  font-size: 32px;

  color: #fc3f56;
  line-height: 40px;
  margin-left: 8px;
}

.FreeLine {
  font-size: 24px;
  color: rgba(252, 63, 86, 1);
  line-height: 36px;
  padding-left: 70px;
}

.exempt {
  font-size: 24px;
  color: @color17;
  line-height: 36px;
}

.pretermissionBox {
  width: 112px;
  height: 56px;
  border-radius: 28px;
  border-top-width: 4px;
  border-bottom-width: 4px;
  border-left-width: 4px;
  border-right-width: 4px;
  border-top-color: rgba(218, 218, 218, 1);
  border-bottom-color: rgba(218, 218, 218, 1);
  border-left-color: rgba(218, 218, 218, 1);
  border-right-color: rgba(218, 218, 218, 1);
  justify-content: center;
}

.pretermissionIcon {
  margin-left: 10px;
  width: 36px;
  height: 36px;
  background-color: rgba(218, 218, 218, 1);
  box-shadow: 0px 4px 8px 0px rgba(231, 231, 231, 0.5);
  border-radius: 100%;
}

.pretermissionActiveBox {
  width: 112px;
  height: 56px;
  border-radius: 28px;
  border-top-width: 4px;
  border-bottom-width: 4px;
  border-left-width: 4px;
  border-right-width: 4px;
  border-top-color: #00bdff;
  border-bottom-color: #00bdff;
  border-left-color: #00bdff;
  border-right-color: #00bdff;
  justify-content: center;
  align-items: flex-end;
}

.pretermissionActiveIcon {
  margin-right: 10px;
  width: 36px;
  height: 36px;
  background-color: @color17;
  box-shadow: 0px 4px 8px 0px rgba(231, 231, 231, 0.5);
  border-radius: 100%;
}
.valueBox {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.valueBox img {
  display: block;
  width: 15px;
  height: 26px;
  margin-left: 19px;
}
.tui-picker-detail {
  font-size: 26px;
  color: #333;
}
</style>